import apiClient from './axiosPetition';
import { toSentenceCase } from './formatServiceName';

export const FALLBACK_PROFESSIONS_GROUPED = {
  Médicos: [
    { value: 'medicina familiar', label: 'Médico familiar' },
    { value: 'medicina general', label: 'Médico general' },
  ],
  Terapias: [
    { value: 'terapeuta respiratorio', label: 'Terapeuta respiratoria' },
    { value: 'terapia física', label: 'Terapeuta física' },
    { value: 'terapeuta ocupacional', label: 'Terapeuta ocupacional' },
    { value: 'terapia de lenguaje', label: 'Terapeuta de lenguaje' },
  ],
  'Otros Profesionales': [
    { value: 'enfermería', label: 'Enfermería' },
    { value: 'nutrición', label: 'Nutrición' },
    { value: 'psicología', label: 'Psicología' },
    { value: 'trabajo social', label: 'Trabajo social' },
  ],
};

export const formatProfessionLabel = (label) => toSentenceCase(label);

const withSentenceLabels = (grouped) => {
  const out = {};
  for (const [group, items] of Object.entries(grouped || {})) {
    out[group] = (items || []).map((item) => ({
      ...item,
      label: toSentenceCase(item.label),
    }));
  }
  return out;
};

export const getServiceLabelFromGrouped = (grouped, value) => {
  if (!value) return '';
  for (const group of Object.values(grouped || {})) {
    const found = group.find((item) => item.value === value);
    if (found) return found.label;
  }
  return value;
};

export const flattenGroupedProfessions = (grouped) =>
  Object.entries(grouped || {}).flatMap(([group, items]) =>
    items.map((item) => ({ ...item, group }))
  );

export async function fetchProfessionsGrouped() {
  try {
    const res = await apiClient.get('/api/professions');
    if (res.data?.grouped && Object.keys(res.data.grouped).length > 0) {
      return withSentenceLabels(res.data.grouped);
    }
    return FALLBACK_PROFESSIONS_GROUPED;
  } catch {
    return FALLBACK_PROFESSIONS_GROUPED;
  }
}

export async function fetchProfessionsFlat() {
  try {
    const res = await apiClient.get('/api/professions');
    if (Array.isArray(res.data?.flat) && res.data.flat.length > 0) {
      return res.data.flat.map((item) => ({
        ...item,
        label: toSentenceCase(item.label),
      }));
    }
    return flattenGroupedProfessions(FALLBACK_PROFESSIONS_GROUPED);
  } catch {
    return flattenGroupedProfessions(FALLBACK_PROFESSIONS_GROUPED);
  }
}
